<style lang="scss" src='./RefreshButton.scss' scoped></style>
<template src="./RefreshButton.html"></template>

<script>

export default {
  name: 'RefreshButton',
  props: {
    onRefresh: {
      type: Function,
      required: true,
    },
  },
  data() {
    return ({
    });
  },
  computed: {
  },

  methods: {
    
    refresh() {
        this.onRefresh();
    }

  },
  mounted() {
  },
};
</script>